import { useFormState } from 'react-hook-form'
import { GraphQL } from '@guestgoodie/graphql'

function findNames(value: unknown, prefix: string = ''): string[] {
  if (!value) return []
  if (typeof value !== 'object') return []

  return Object.entries(value).flatMap(function ([key, value]) {
    if (Array.isArray(value)) {
      return value.flatMap((v, index) =>
        findNames(v, `${prefix}${key}.${index}.`)
      )
    }

    // when we see a `ref` we know that we came to the end of the object
    if (typeof value === 'object' && !('ref' in value)) {
      return findNames(value, `${prefix}${key}.`)
    }

    return `${prefix}${key}`
  })
}

export function useExtractLocalizedErrors(defaultLocale: GraphQL.AppLocale) {
  const { errors } = useFormState()

  let finalLocalizedErrors: Record<string, GraphQL.AppLocale[]> = {}
  const { translations, ...rest } = errors

  if (translations && typeof translations === 'object') {
    finalLocalizedErrors = Object.entries(translations).reduce<
      Record<string, GraphQL.AppLocale[]>
    >(function (acc, [loc, value]) {
      findNames(value).forEach(name => {
        if (name in acc) acc[name].push(loc as GraphQL.AppLocale)
        else acc[name] = [loc as GraphQL.AppLocale]
      })

      return acc
    }, {})
  }

  findNames(rest).forEach(name => {
    if (name in finalLocalizedErrors) {
      finalLocalizedErrors[name].push(defaultLocale)
    } else finalLocalizedErrors[name] = [defaultLocale]
  })

  return finalLocalizedErrors
}
